// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupList_container__2eKf2"};